import React from 'react'
import Button from '@material-ui/core/Button';
import Schedule from '@material-ui/icons/Schedule'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Typography } from '@material-ui/core';

export const RedirectButton = ({url, text}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Button
      variant="contained"
      size="large"
      startIcon={<Schedule />}
      className={[classes.button, "buttons"].join(' ')}
      id="queues-redirectbutton-id"
      disableElevation
      onClick={() => window.open(url)}
      >
      { <Typography id="queues-redirectbutton-text-id">{text || "Boka tid"}</Typography> }
    </Button>
  )
}

const useStyles = makeStyles({
  button: theme => ({
    color: theme.palette.button_text.main,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 0,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.button_text.main
      }
    }
  })
})